
import { takeEvery, call, put } from "redux-saga/effects"
import { FETCH_COMMISSION, SET_COMMISSION, ADD_MESSAGE } from '../actionTypes'
import axios from "axios"


const fetchCommissionData = (filter) => {
  return axios({
    method: 'get',
    url: '/api/rabbit/commission',
    params: filter
  })
}

function* workerFetchCommission(payload) {
    try {
        const {filter} = payload
        yield put({type: SET_COMMISSION, commission: []})

        const resp = yield call(fetchCommissionData, filter)
        const commission = resp.data || []

        yield put({type: SET_COMMISSION, commission})
      } catch (e) {
        yield put({type: ADD_MESSAGE, message: `unable to Fetch Commission`})
      }
  }
  
export function* watchFetchCommissionSaga() {
    yield takeEvery(FETCH_COMMISSION, workerFetchCommission)
}

